import { keyExists } from '../../../utils';
import { fieldOperatorAndNotValue, onlyValue } from './termUtils';
export function getExamplesList(term, examplesLookup) {
    if (onlyValue(term) && keyExists(examplesLookup, term.value)) {
        return examplesLookup[term.value.toString()];
    }
    if (fieldOperatorAndNotValue(term)) {
        return examplesLookup[term.field] || [];
    }
    return [];
}
